/**
 * @desc准入注册
 * @created: 2020/4/6 16:19:00
 * @author: lijun
 * @version : v1.0
 */
import request from '@/plugins/http'
import qs from 'qs'

// 列表查询
export const getListData = (params) => {
  return request.get('/servicerApply/list', params)
}

// 准入注册-列表查询
export const accessAudit = (data) => {
  return request.post('/servicerApply/audit', qs.stringify(data))
}
